import { Pipe, PipeTransform } from "@angular/core";
import { DiscountTypeEnum } from "src/domain/client";
import { FormService } from "../services/form.service";
import { Store } from "@ngrx/store";
import { selectCampaignResponse } from "../state";

@Pipe({
  name: "discountPrice",
  pure: false,
})
export class DiscountPricePipe implements PipeTransform {
  constructor(
    private formService: FormService,
    private store: Store
  ) {}

  transform(value: number): number {
    const campaignResponse = this.store.selectSignal(selectCampaignResponse);
    let returnValue = 0;
    if (!this.formService.hasValidCampaignCode) return value;
    if (campaignResponse().discountType === DiscountTypeEnum.Fixed) {
      returnValue = value - campaignResponse().discount;
    }
    if (campaignResponse().discountType === DiscountTypeEnum.Percentage) {
      returnValue = Math.round((1 - campaignResponse().discount) * value);
    }
    if (returnValue <= 0) returnValue = 0;
    return returnValue;
  }
}
